// export const url = 'http://localhost:8000';
export const sendInBlueApiKey = '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';
export const sendInBlueUrl = 'https://api.sendinblue.com/v3/contacts';
export const url = 'https://mg-seedout-backend.herokuapp.com';
